export const buttonsStyle = {width: '50%', textAlign: 'center'} as const
export const groupRadioStyle = {width: '100%'}
